export default "__VITE_ASSET__DfwGUVHN__"